
export interface UserPinResponse {
  status: API_STATUS;
  value?: {
    flowKey: string,
    aliases: [],
    accountFirstName: string,
  };
  message: string;
  messageCode: string;
  responseCode: number;
}

export interface UserCreateResponse {
  status: API_STATUS;
  message: string;
  messageCode: string;
  responseCode: number;
  value?: any;
}

export interface DefaultResponse {
  status: API_STATUS;
  message: string;
  messageCode: string;
  value: string;
}

export enum API_STATUS {
  NOT_AUTHENTICATED = 'notAuthenticated',
  SUCCESS = 'success',
  FAILURE = 'failure',
  INTERNAL_FAILURE = 'internalFailure',
}
